import { isNil, isUndefined } from 'lodash';

export const extractHistogramXyRange = (metadata: any) => {
  const statistics = metadata?.statistics;
  const bandMetadata =
    metadata?.band_metadata?.reduce((acc, band) => {
      acc[band[0]] = band[1];
      return acc;
    }, {}) || {};

  const minY = 0;
  let maxY = 0;
  let minX = 2147483647;
  let maxX = -2147483646;

  for (const i in statistics) {
    const bandMetadataMin = Number(bandMetadata[i]?.['STATISTICS_MINIMUM']);
    const bandMetadataMax = Number(bandMetadata[i]?.['STATISTICS_MAXIMUM']);

    if (bandMetadataMin && bandMetadataMax) {
      minX = Math.min(minX, bandMetadataMin);
      maxX = Math.max(maxX, bandMetadataMax);
    }

    const bandStatistics = statistics[i];

    minX = Math.min(minX, bandStatistics.min);
    maxX = Math.max(maxX, bandStatistics.max);
    maxY = Math.max(maxY, Math.max(...bandStatistics.histogram[0]));
  }

  return {
    minX,
    maxX,
    minY,
    maxY,
  };
};

export const getInitialRescaleValue = (
  metadata: any,
  sourceFilePath: string,
) => {
  if (isNil(metadata) || !sourceFilePath) {
    return;
  }

  const { minX: minValue, maxX: maxValue } = extractHistogramXyRange(metadata);

  if (metadata && !isUndefined(minValue) && !isUndefined(maxValue)) {
    const initialRescaleValue = `${Math.floor(minValue)},${Math.ceil(
      maxValue,
    )}`;

    return initialRescaleValue;
  }
};
